/**
 * Перенос `lib/src/config/endpoints.dart` — адреса один в один.
 *
 * `baseUrlPlaceholder` и `langPlaceholder` — это литеральные подстроки внутри
 * путей, которые перехватчик пути (`PathInterceptor`) заменяет на реальные
 * значения перед отправкой запроса. Поэтому строки должны совпадать с
 * Dart-версией символ в символ: в Dart они записаны как `'\${baseUrl}'`,
 * то есть без интерполяции. В TypeScript для этого используются одинарные
 * кавычки — в них `${...}` тоже не подставляется.
 */

/** Литерал `${baseUrl}` — заменяется на сохранённый адрес сервера. */
const BASE_URL_PLACEHOLDER = '${baseUrl}';

/** Литерал `${lang}` — заменяется на `AppLanguage.param` текущего языка. */
const LANG_PLACEHOLDER = '${lang}';

export const Endpoints = {
  baseUrlPlaceholder: BASE_URL_PLACEHOLDER,

  langPlaceholder: LANG_PLACEHOLDER,

  personChange: (personBaseUrl: string): string =>
    `${personBaseUrl}/v1/person/select_person/`,

  selectLanguage: (personBaseUrl: string): string =>
    `${personBaseUrl}/v1/person/select_language/`,

  personInterrupt: (personBaseUrl: string): string =>
    `${personBaseUrl}/v1/human/interrupt`,

  personMoodState: (personBaseUrl: string): string =>
    `${personBaseUrl}/v1/animate/mood`,

  // static const testBaseUrl = 'https://api.ulugbek.hron.uz/';

  // static const testBaseUrl = 'http://172.30.82.141:8040/';

  // static const testBaseUrl = 'https://api.ulugbek.hron.uz/';

  testBaseUrl: 'https://api.ulugbek.hron.uz/work_test/',

  checkPinCode: `${BASE_URL_PLACEHOLDER}/${LANG_PLACEHOLDER}/api/v1/check-pin/`,

  /**
   * Публичный список планшетов сервера. Отвечает без авторизации,
   * `limit` не больше 100.
   */
  publicTablets: (serverRoot: string): string =>
    `${serverRoot}/api/v1/tablets/public`,

  /** Вход планшета: `{slug, password}` → `{token, refresh_token}`. */
  tabletsAuth: (serverRoot: string): string => `${serverRoot}/api/v1/tablets/auth`,

  /** Защищённая конфигурация с полными STT (`api_key`). Bearer-токен. */
  tabletsConfig: (serverRoot: string): string =>
    `${serverRoot}/api/v1/tablets/config`,

  /**
   * Обновление токена: `?refresh_token=…` → `{token, refresh_token?}`
   * (`refresh_token` — если бекенд его ротирует).
   */
  tabletsRefresh: (serverRoot: string): string =>
    `${serverRoot}/api/v1/tablets/refresh`,

  /**
   * Предустановленные серверы для экрана адреса. Нормализованы:
   * `scheme://host`, без хвостового слеша.
   *
   * Тип намеренно `readonly string[]`, а не кортеж литералов: вызывающий код
   * делает `knownServerPresets.includes(root)` с произвольной строкой.
   */
  knownServerPresets: [
    'https://api.lp.iccu.uz',
    'https://api.lp.devr.uz',
    'https://lp.hron.uz',
  ] as readonly string[],

  personQuestions: (personId: number): string =>
    `${BASE_URL_PLACEHOLDER}/${LANG_PLACEHOLDER}/api/v1/person-questions/${personId}/`,
} as const;
